function addUpcartCustomSections() {
    const paymentIconsWrapper = document.querySelector(".upcart-payment-icons:not(.edited)");
    const trustBadgesWrapper = document.querySelector(".upcart-trust-badges:not(.edited)");
    const customHeaderMsgWrapper = document.querySelector(".upcart-custom-message-wrapper:not(.edited)");

    if (!paymentIconsWrapper || !trustBadgesWrapper || !customHeaderMsgWrapper) return;

    paymentIconsWrapper.innerHTML = window.upcartCustomization.paymentIcons;
    trustBadgesWrapper.innerHTML = window.upcartCustomization.trustBadges;
    customHeaderMsgWrapper.innerHTML = window.upcartCustomization.customHeaderMsg;
    
    paymentIconsWrapper.classList.add("edited");
    trustBadgesWrapper.classList.add("edited");
    customHeaderMsgWrapper.classList.add("edited");

    handleTimeOffer();
}

function handleTimeOffer() {
    // Check if time offer already exists to prevent duplicates
    if (document.querySelector(".upcart-time-offer-module")) return;
    
    const retryDelays = [0, 250, 500, 1000];
    
    const tryInsertTimeOffer = (attemptIndex = 0) => {
        const upsellsWrapper = document.querySelector(".upcart-upsells-module:not(.edited)");
        
        if (upsellsWrapper) {
            insertTimeOffer(upsellsWrapper);
            upsellsWrapper.classList.add("edited");
            return;
        }
        
        if (attemptIndex < retryDelays.length - 1) {
            const nextDelay = retryDelays[attemptIndex + 1];
            setTimeout(() => tryInsertTimeOffer(attemptIndex + 1), nextDelay);
        } else {
            // All attempts exhausted, insert before bottomModules as fallback
            const bottomModules = document.querySelector("#upCart .styles_CartPreview__bottomModules__:not(.edited)");
            if (bottomModules) {
                insertTimeOffer(bottomModules);
                bottomModules.classList.add("edited");
            }
        }
    };

    tryInsertTimeOffer();
}

function insertTimeOffer(targetElement) {
    if (!window.upcartCustomization.timeOffer.enabled) return;

    const timeOfferHTML = `
        <div class="upcart-time-offer-module" style="--bg-image: url('${window.upcartCustomization.timeOffer.bgImage}');">
            <h3>${window.upcartCustomization.timeOffer.title}</h3>
            <p>${window.upcartCustomization.timeOffer.subtitle}</p>
        </div>
    `;

    targetElement.insertAdjacentHTML('beforebegin', timeOfferHTML);
}

document.addEventListener('DOMContentLoaded', function () {
    window.upcartSubscribeCartLoaded(({ cart }) => {
        addUpcartCustomSections();
    });

    window.upcartSubscribeCartUpdate(({ cart }) => {
        addUpcartCustomSections();
    });
});